import React from 'react'

const SubtractIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M20 11.9998L4 12.0009" stroke="#B6B6BA" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default SubtractIcon
